<template>
  <!-- https://buefy.org/documentation/field#addons -->
  <b-field class="form_field_filter">
    <b-dropdown
      class="checkbox_dropdown"
      multiple
    >
      <template #trigger>
        <b-button
          icon-right="menu-down"
          size="is-small"
        >
          {{ label }}
        </b-button>
      </template>

      <div class="all_button--container">
        <button
          @click="selectAll"
          class="all_button"
        >select all</button>
        <button
          @click="deselectAll"
          class="all_button"
        >deselect all</button>
      </div>

      <b-dropdown-item
        v-for="user in users"
        :key="user.id"
        :value="user.id"
      >
        <b-checkbox
          v-model="userIds"
          :native-value="user.id"
          @input="handleInput"
        >
          {{ user.full_name }}
        </b-checkbox>
      </b-dropdown-item>
    </b-dropdown>
  </b-field>

</template>

<script>
import FormField from "../../form/FormField";
import {FormFieldMixin} from "../../form/FormField.mixin";

export default {
    name: "FilterFieldUsers",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {
        type: Array,
        required: true,
      },
      label: {
        type: String,
        required: true
      },
      users: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        userIds: [],
      }
    },
    created() {
      this.userIds = this.value;
    },
    methods: {
      selectAll() {
        // set userIds so checkboxes change
        this.userIds = this.users.map(user => {
          return user.id;
        });
        this.handleInput(this.userIds);
      },
      deselectAll() {
        // set userIds so checkboxes change
        this.userIds = [];
        this.handleInput(this.userIds);
      },
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.all_button--container {
  padding: 0 10px 8px;
}

.all_button {
  color: $link;
  font-size: 12px;

  &:hover {
    color: $link-hover;
  }
}
</style>
